import { render, staticRenderFns } from "./AsyncButton.vue?vue&type=template&id=37388e36&"
import script from "./AsyncButton.vue?vue&type=script&lang=ts&"
export * from "./AsyncButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports